/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component, Fragment } from 'react'
// import UserProfile from '../components/Profile/Profile'
import './profileUser.scss'
import Navbar from "../../components/newNavbar/navbar";
import ProfileLoggedIn from "../../components/profileLoggedIn/profileLoggedIn";
import ErrorBroundray from '../../components/errorBoundary/errorBoundary'

// import ActivityCard from "../../components/activityCard/activityCard"

export default class ProfileUser extends Component {

    constructor(props) {
        super(props);
        this.state = {
            path: 1,
            player: {}
        }

        this.player = {}


    }

    componentDidMount() {
        const location = window.location;

        const linksArray = document.querySelectorAll(
            'div.sub-nav > ul > li > a'
        );

        // console.log(location.pathname);

        // console.log(linksArray);

        for (let i = 0; i < linksArray.length; i++) {
            const elementClass = linksArray[i].className;
            const element = linksArray[i].pathname;
            const pureElement = linksArray[i];

            // console.log(element);

            if (elementClass.includes("active")) {
                pureElement.className = '';
            }

            if (location.pathname === element) {
                pureElement.classList.add("active");
            }
        }
    }

    componentDidUpdate() {
        const location = window.location;

        const linksArray = document.querySelectorAll(
            'div.sub-nav > ul > li > a'
        );

        for (let i = 0; i < linksArray.length; i++) {
            const elementClass = linksArray[i].className;
            const element = linksArray[i].pathname;
            const pureElement = linksArray[i];

            if (elementClass.includes("active")) {
                pureElement.className = '';
            }

            if (location.pathname === element) {
                pureElement.classList.add("active");
            }
        }

    }

    render() {

        const cache = JSON.parse(sessionStorage.getItem('OITO'));

        // console.log(cache)

        if (cache) {
            this.player = cache.user
        } else {
            if (!this.state.showAlert) this.setState({
                showAlert: true,
                typeAlert: 'error',
                titleAlert: 'Você não está logado',
                messageAlert: 'Entre ou cadastre-se. É gratuito!',
                onClose: () => window.location.href = '/login'
            })
            window.setTimeout(window.location.href = '/login', 2000)
        }

        const LastURL = JSON.parse(sessionStorage.getItem('LastURL'))
        if (LastURL) {
            if (LastURL.path !== window.location.pathname) {
                sessionStorage.removeItem('LastURL')
                window.history.go(parseInt(LastURL.count) - 1)

            }
        }

        return (
            <Fragment>
                <ErrorBroundray><Navbar /></ErrorBroundray>

                <div className={'profileUserLoggedIn col-xs-12'}>
                    <div className="row center-xs middle-xs">
                        <ErrorBroundray><ProfileLoggedIn userInfo={this.player} /></ErrorBroundray>
                        <div className="col-xs-12" style={{ marginBottom: '40px' }}>
                            <div className="row center-xs middle-xs">
                                <ErrorBroundray>{this.props.childrencomponent}</ErrorBroundray>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}
